import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { MonthlyStats } from "../../services/packageService";

interface VolumeChartProps {
  data: MonthlyStats[];
}

export default function VolumeChart({ data }: VolumeChartProps) {
  const options: ApexOptions = {
    colors: ["#DC4A4A", "#22C55E", "#8B5CF6"], // Escorts (coral), Outgoing (green), Incoming (purple)
    chart: {
      fontFamily: "Outfit, sans-serif",
      type: "bar",
      height: 280,
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: data.length > 14 ? "85%" : "50%",
        borderRadius: data.length > 14 ? 2 : 4,
        borderRadiusApplication: "end",
        borderRadiusWhenStacked: "last",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["transparent"],
    },
    xaxis: {
      categories: data.map((d) => d.month),
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        rotate: -45,
        rotateAlways: false,
        hideOverlappingLabels: true,
        showDuplicates: false,
        trim: false,
        style: {
          fontSize: "11px",
        },
        formatter: function (value: string) {
          // Format date string to "MMM Dth" format (e.g., "Nov 19th")
          if (!value) return value;
          const date = new Date(value);
          if (isNaN(date.getTime())) return value;
          const month = date.toLocaleDateString("en-US", { month: "short" });
          const day = date.getDate();
          const ordinal = (n: number) => {
            const s = ["th", "st", "nd", "rd"];
            const v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
          };
          return `${month} ${ordinal(day)}`;
        },
      },
      tickAmount: data.length,
    },
    yaxis: {
      title: {
        text: "Count",
        style: {
          fontSize: "12px",
          color: "#6B7280",
        },
      },
    },
    legend: {
      show: true,
      position: "top",
      horizontalAlign: "left",
      fontFamily: "Outfit",
      markers: {
        size: 8,
        shape: "circle",
      },
    },
    grid: {
      yaxis: {
        lines: {
          show: true,
        },
      },
      borderColor: "#E5E7EB",
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val.toLocaleString()}`,
      },
    },
  };

  const series = [
    {
      name: "Escorts",
      data: data.map((d) => d.escorts),
    },
    {
      name: "Outgoing",
      data: data.map((d) => d.outgoing),
    },
    {
      name: "Incoming",
      data: data.map((d) => d.incoming),
    },
  ];

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] sm:p-6">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-800 dark:text-white/90">
          Chart Summary
        </h3>
      </div>
      <div className="max-w-full overflow-x-auto custom-scrollbar">
        <div className="min-w-[500px]">
          <Chart options={options} series={series} type="bar" height={280} />
        </div>
      </div>
    </div>
  );
}
